const Join = () => {
  return (
    <section id="discord">
      <div className="container">
        {/* ======================= main heading =================== */}
        <h2 data-aos="fade-up">Join the Community</h2>
        {/* ================ body text =============================== */}
        <p data-aos="fade-up">
          Be involved, discuss the future of streaming, get the latest project updates,
          chill in the #lounge, meet new people, ask a question, participate in
          competitions, win free airdrops and make us laugh with your favourite
          memes. It’s all happening in our Discord server!
        </p>
        <div>
          {/* ================ join discord button =============== */}
          {/* ================= add your link in href=" "  ======================*/}
          <a
            data-aos="fade-up"
            data-aos-duration="1500"
            href="https://discord.gg/WeStream"
            target="_blank"
            rel="noopener noreferrer"
            className="cta"
          >
            Join our Discord
          </a>
        </div>
      </div>
    </section>
  );
};

export default Join;
